module.exports = __webpack_public_path__ + "img/GXLT.41698a4a.svg";